import { resources } from "@constants/hardcoded-strings";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";

type SecurityRuleStatusSelectFormGroupProps = BaseSelectFormGroupProps;


export const SecurityRuleStatusSelectFormGroup = (props: SecurityRuleStatusSelectFormGroupProps) => {
    const { onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const securityRuleStatusOptions = [
        { label: resources.common.active, value: EntityStatusTypes.ACTIVE },
        { label: resources.common.inactive, value: EntityStatusTypes.INACTIVE }
    ];

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-security-rule-status-select`}
            label={resources.common.inputs.status.label}
            ariaLabel={resources.common.inputs.status.label}
            automationId={`${idPrefix}-security-rule-status-select`}
            onChange={onChange}
            options={securityRuleStatusOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};